<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  price: { type: Object, default: () => ({}) },
  businessContext: {
    type: String,
    default: 'rental',
    validator: value =>
      ['rental', 'purchase', 'rent', 'sale', 'alugar', 'comprar'].includes(
        value
      ),
  },
  density: {
    type: String,
    default: 'inline',
    validator: value => ['inline', 'panel'].includes(value),
  },
});

const { t } = useI18n();
const normalizedContext = computed(() =>
  ['purchase', 'sale', 'comprar'].includes(props.businessContext)
    ? 'purchase'
    : 'rental'
);
const label = computed(
  () =>
    props.price?.label ||
    (normalizedContext.value === 'purchase'
      ? t('PROPERTIES.PRICE.SALE_LABEL')
      : t('PROPERTIES.PRICE.RENT_LABEL'))
);
const formatted = computed(
  () => props.price?.formatted || t('PROPERTIES.CARD.PRICE_ON_REQUEST')
);
const suffix = computed(() => {
  if (props.price?.monthlySuffix) return props.price.monthlySuffix;
  if (normalizedContext.value === 'rental' && !props.price?.priceOnRequest) {
    return t('PROPERTIES.PRICE.MONTH_SUFFIX');
  }
  return '';
});
const isPanel = computed(() => props.density === 'panel');
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section
    class="grid gap-1"
    :class="
      isPanel
        ? 'rounded-lais border border-lais-border-soft bg-lais-bg-card p-4 shadow-lais-card'
        : 'text-[12px] text-lais-text-muted'
    "
    data-test="classified-price-box"
    :data-business-context="normalizedContext"
    :aria-label="`${label}: ${formatted}`"
  >
    <p
      :class="
        isPanel
          ? 'text-[12px] font-semibold uppercase text-lais-text-muted'
          : ''
      "
    >
      <strong v-if="!isPanel" class="text-lais-text">{{ label }}:</strong>
      <template v-else>{{ label }}</template>
      <span
        :class="
          isPanel
            ? 'mt-1 block text-lais-heading-md font-semibold text-lais-primary'
            : 'ml-1 font-semibold text-lais-text'
        "
      >
        {{ formatted }}
      </span>
      <span
        v-if="suffix"
        :class="isPanel ? 'ml-1 text-lais-body-sm normal-case' : 'ml-1'"
      >
        {{ suffix }}
      </span>
    </p>
    <p v-if="price.totalLabel" class="text-lais-text-helper">
      {{ price.totalLabel }}
    </p>
  </section>
</template>
